export const SERVER = 'https://www.nfgy.com';
// export const SERVER = 'http://localhost:7001';
